module.exports = __webpack_public_path__ + "media/recipes/64-a45a0734.png";